<div class="oc-table">
  <div class="oc-head">
    <div class="oc-h">{{ 'AI_PARSER_DOCUMENT' | translate }}</div>
    <div class="oc-h">{{ 'AI_PARSER_FROM' | translate }}</div>
    <div class="oc-h">{{ 'AI_PARSER_RECEIVED' | translate }}</div>
    <div class="oc-h oc-h-config">{{ 'AI_PARSER_CONFIG' | translate }}</div>
    <div class="oc-h">{{ 'AI_PARSER_CUSTOMER_ORDER_NO' | translate }}</div>
    <div class="oc-h">{{ 'AI_PARSER_ORDER_NO' | translate }}</div>
    <div class="oc-h oc-h-rows oc-num">{{ 'AI_PARSER_ROWS' | translate }}</div>
    <div class="oc-h oc-h-status">{{ 'AI_PARSER_STATUS' | translate }}</div>
    <div class="oc-h"></div>
  </div>

  <div class="oc-body">
    <div *ngFor="let item of items; trackBy: trackById" class="oc-row-host">
      <ng-template libCustomHost></ng-template>
    </div>
  </div>
</div>
